import { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { cabAction } from "../../store/Cab/CAbReducer"
import { SESSION_EXPIRED_TOAST } from "../../utils/sessionCookie"
import { clearAllPulpitClientStorage } from "../../utils/clientStorage"

/**
 * Handles get_trip_fare (getCabs) session rejection: redirect home + toast once.
 */
export default function SessionExpiryListener() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const sessionExpiredRedirect = useSelector((s) => s.cab.sessionExpiredRedirect)
  const toastLock = useRef(false)

  useEffect(() => {
    if (!sessionExpiredRedirect) {
      toastLock.current = false
      return
    }
    if (toastLock.current) return
    toastLock.current = true
    clearAllPulpitClientStorage({ keepRecentSearches: true })
    dispatch(cabAction.resetCabBookingContext())
    toast.warning(SESSION_EXPIRED_TOAST)
    navigate("/", { replace: true })
    dispatch(cabAction.clearSessionExpired())
  }, [sessionExpiredRedirect, navigate, dispatch])

  return null
}
